import Resource from '@/api/resources/Resource'
import StudyRequest from '@/api/models/StudyRequest'

class ClinicalRequestService extends Resource {
    async addAttachment(labId, requestId, params) {
        const formData = new FormData()

        formData.append('file', params.file)
        formData.append('atyId', params.atyId)
        formData.append('notes', 'notes')
        return this.axios.post(`/clinical/laboratories/${labId}/requests/${requestId}/attachments`, formData, { headers: { 'content-type': 'multipart/form-data' } })
            .then(response => response.data)
    }

    async attachment(labId, requestId, ratId) {
        return this.axios.get(`/clinical/laboratories/${labId}/requests/${requestId}/attachments/${ratId}`,
            {
                headers: { 'content-type': 'multipart/form-data' },
                responseType: 'blob'
            })
            .then(response => response.data)
    }

    async deleteAttachment(labId, requestId, ratId) {
        return this.axios.delete(`/clinical/laboratories/${labId}/requests/${requestId}/attachments/${ratId}`)
            .then(response => response.data)
    }

    async create(labId, params) {
        return this.axios.post(`/clinical/laboratories/${labId}/requests`, params)
    }

    async edit(labId, requestId, params) {
        return this.axios.put(`/clinical/laboratories/${labId}/requests/${requestId}`, params).then(response => response.data)
    }

    async formalize(labId, requestId, params) {
        return this.axios.put(`/clinical/laboratories/${labId}/requests/${requestId}/formalize`, params)
    }

    async batchCancel(identifiers) {
        return this.axios.put(`/clinical/laboratories/requests/cancel`, { entityIdentifiers: identifiers })
    }

    async batchDiscard(identifiers) {
        return this.axios.put(`/clinical/laboratories/requests/discard`, { entityIdentifiers: identifiers })
    }

    async get(labId, id) {
        return this.axios.get(`/clinical/laboratories/${labId}/requests/${id}`).then(response => new StudyRequest(response.data))
    }

    async index(aParams) {
        const params = aParams || { page: 0, size: 100 }
        const response = await this.axios.put('/clinical/laboratories/requests/myRequests', { params })
        return response.data.content
    }

    async paginator(filterModel, params, url = '/clinical/laboratories/requests/myRequests') {
        const response = await this.axios.put(url, filterModel, { params })
        return response.data
    }

    async predefinedFiltersSummary() {
        return this.axios.get('/clinical/laboratories/requests/summary').then(response => response.data)
    }

    async searchRequestByCaseNumber(caseNumber) {
        const params = { caseNumber: caseNumber }
        return this.axios.get(`/clinical/laboratories/cases/searchByCaseNumber`, { params }).then(response => response.data)
    }

    async searchRequestByLabel(label) {
        const params = { label: label }
        return this.axios.get(`/clinical/laboratories/requests/searchByLabel`, { params }).then(response => response.data)
    }
}

export default new ClinicalRequestService()
